import { jwtDecode } from 'jwt-decode';

export const jwt_decode = () => {
  const accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    try {
      const decoded_jwt: any = jwtDecode(accessToken);
      return decoded_jwt;
    } catch (error) {
      console.error("Invalid token:", error);
    }
  }
  return null;
};